const addCompanyNameToComment = (form) => {
    const compNameInput = form.querySelector('input[name="company_name"]');
    const commentInput = form.querySelector('textarea[name="commentary"]');
    if (compNameInput.value != '') {
        commentInput.value = compNameInput.value + '\n' + commentInput.value;
    }
};
export default addCompanyNameToComment;
